import request from '@/service/request'
enum Api {
  GET_AGENCYAREA_LIST = '/agency/list',
  GET_AGENCYAREA_DETAIL = '/agency/detail',
  AGENCY_DELETE = '/agency/delete',
  AGENCY_EDIT = '/agency/edit',
  AGENCY_LISTTHAGENCY = '/agency/listThAgency',
  AGENCY_SAVE = '/agency/save'
}

export default class agencyAreaService {
  /**
   * 代理区列表
   * @param data
   * @returns
   */
  static getAgencyAreaList(data: Record<string, any>): Promise<any> {
    return request.post(Api.GET_AGENCYAREA_LIST, data)
  }
  static queryJmsDimAgency(data: Record<string, any>): Promise<any> {
    return request.post('/courier/dimNet', data)
  }
  /**
   * 代理区详情
   * @param data
   * @returns
   */
  static getAgencyAreaDetail(data: any): Promise<any> {
    return request.post(Api.GET_AGENCYAREA_DETAIL, data)
  }
  /**
   * 代理区删除
   * @param data
   * @returns
   */
  static delete(data: any): Promise<any> {
    return request.post(Api.AGENCY_DELETE, data)
  }
  /**
   * 代理区编辑
   * @param data
   * @returns
   */
  static edit(data: any): Promise<any> {
    return request.post(Api.AGENCY_EDIT, data)
  }
  /**
   * 代理区查询列表-名称模糊
   * @param data
   * @returns
   */
  static listThAgency(data: any): Promise<any> {
    return request.post(Api.AGENCY_LISTTHAGENCY, data)
  }
  /**
   * 代理区保存
   * @param data
   * @returns
   */
  static save(data: any): Promise<any> {
    return request.post(Api.AGENCY_SAVE, data)
  }
}
